import { Component, Input } from "@angular/core";
import { Community } from "../../../../models";

@Component({
  selector: "del-community-button",
  templateUrl: "./del-community-button.component.html",
  styleUrls: [
    "./del-community-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DelCommunityButtonComponent {
  @Input() community: Community;
  constructor() {}
  ngOnInit() {}
}
